import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { defineMessages, useIntl } from 'react-intl';
import styled from 'styled-components';
import { tokens } from '@companycam/slab';
import { Button } from '@companycam/slab-web';
import { NewBadge } from 'components/shared/Badge';

// #region styled-components
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
`;

const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: var(--cc_size_spacing_m);
`;

const ConfirmTitle = styled.h3`
  font-size: var(--cc_size_text_xxl);
  line-height: 40px;
  font-weight: 900;
  font-family: 'Averta', system-ui, -apple-system, BlinkMacSystemFont,
    'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  margin: 0;
`;

const ConfirmMessage = styled.p`
  display: block;
  color: ${tokens.color_text_subtle_le};
  white-space: pre-line;
  line-height: 1.4;
  margin-bottom: var(--cc_size_spacing_m);
`;
// #endregion

const messages = defineMessages({
  defaultConfirmLabel: {
    id: 'Shared.messageModal.defaultConfirmLabel',
    defaultMessage: 'Okay',
    description: 'Default message for confirm label',
  },
});

const MessageModal = ({
  confirmAction,
  confirmLabel,
  message,
  title,
  onRequestClose,
  isNew,
  titleStyle,
  messageStyle,
  modalWidth,
}) => {
  const intl = useIntl();
  return (
    <Modal
      ariaHideApp={false}
      contentLabel={intl.formatMessage(messages.defaultConfirmLabel)}
      isOpen
      overlayClassName="modal"
      className="modal-content-wrap"
      onRequestClose={onRequestClose}
      style={{
        content: {
          width: modalWidth,
        },
      }}
    >
      <Wrapper>
        <MessageWrapper>
          {isNew ? <NewBadge /> : null}
          <ConfirmTitle style={titleStyle}>{title}</ConfirmTitle>
          <ConfirmMessage style={messageStyle}>{message}</ConfirmMessage>
        </MessageWrapper>
        <Button
          color="primary"
          size="large"
          style={{ width: '100%' }}
          onClick={confirmAction}
          data-testid="confirmation-modal__accept"
        >
          {confirmLabel || intl.formatMessage(messages.defaultConfirmLabel)}
        </Button>
      </Wrapper>
    </Modal>
  );
};

MessageModal.propTypes = {
  confirmAction: PropTypes.func,
  confirmLabel: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  title: PropTypes.string,
  onRequestClose: PropTypes.func,
  isNew: PropTypes.bool,
  titleStyle: PropTypes.object,
  messageStyle: PropTypes.object,
  modalWidth: PropTypes.number,
};

export default MessageModal;
